export function initTabs() {
  const root = document.querySelector("[data-tabs]");
  if (!root) return;

  const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
  const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
  const tablist = root.querySelector('[role="tablist"]');
  const panelsContainer = root.querySelector(".tab-panels");

  function activate(tab, focus = true, scrollToPanel = false) {
    const panelId = tab.getAttribute("aria-controls");

    tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute("aria-selected", String(selected));
      t.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((p) => {
      p.hidden = p.id !== panelId;
    });

    // Scroll active panel into view only when user clicked or used keyboard (not on page load)
    if (scrollToPanel && panelsContainer) {
      const prefersReducedMotion = window
        .matchMedia("(prefers-reduced-motion: reduce)")
        .matches;

      panelsContainer.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "start",
      });
    }

    if (focus) tab.focus({ preventScroll: true });

    // Only sync the hash when the user activates a tab (click / Enter / Space).
    // Otherwise the first `activate()` on page load would clutter the URL after
    // navigating from the header with a clean path (e.g. services-systems-integrations.html).
    if (scrollToPanel) {
      history.replaceState(null, "", `#${tab.id.replace("tab-", "")}`);
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activate(tab, false, true));
  });

  if (tablist) {
    tablist.addEventListener("keydown", (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i === -1) return;

      if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        e.preventDefault();
        tabs[(i + 1) % tabs.length].focus();
      }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
        e.preventDefault();
        tabs[(i - 1 + tabs.length) % tabs.length].focus();
      }
      if (e.key === "Home") {
        e.preventDefault();
        tabs[0].focus();
      }
      if (e.key === "End") {
        e.preventDefault();
        tabs[tabs.length - 1].focus();
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        activate(document.activeElement, true, true);
      }
    });
  }

  const hash = location.hash.replace("#", "");
  const startTab = document.getElementById(`tab-${hash}`) || tabs[0];
  if (startTab) {
    activate(startTab, false, false); // no scroll on page load
  }
}

